<template>
  <div class="vx-card">
    <div class="vx-row ml-5 mr-5" style="margin-top:30px; margin-bottom:99px">
      <div class="vx-col w-full"></div>
      <div id="app">

      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";



export default {
  components: {
  },
  data() {
    return {
      imageList: [],

      inputFile: [],
      files: [],
    };
  },

  computed: {},
  methods: {
    GetCarCanbusData: async function() {
      this.$vs.loading();
      this.obdTalkParamList = await repository.postFile("ResearchAndDevelopment/GetCarCanbusData").then((r) => r.list);
      this.$vs.loading.close();
    },

    inputFilter: async function() {
      console.log("test");
      await repository.postFile("ResearchAndDevelopment/CreateFirmwareFile",this.files, "_files");
      return true;
    },

    uploadFirmware: async function() {
      console.log("test");
      await repository.postFile("ResearchAndDevelopment/CreateFirmwareFile", this.imageList, "_files");
      return true;
    },

  },

 
  created() {},
};
</script>
